/***
 *
 * Please Do not use this Component.
 */

import { useRef, useState, useEffect } from "react";
import styles from "./Badges.module.css";
import { useBadges } from "../../../hooks/badges";
import { useLoadMore } from "../../../hooks/loadMore";
import { ALMLoader } from "../../Common/ALMLoader";
import { BadgeList } from "../BadgeList";
import { useIntl } from "react-intl";
import { Provider, lightTheme } from "@adobe/react-spectrum";


const Badges = (props: any) => {
  const {
    badges,
    loadMoreBadge,
    isLoading,
    isNextDisable,
    isPrevDisable,
    handleDownloadPdfClick,
    handleDownloadImgClick,
    handleNextPage,
    handlePrevPage,
    handleRedirectToCourse,
    handleDownloadAllCheckedPdf,
    handleDownloadAllCheckedImg
  } = useBadges();

  const { formatMessage } = useIntl();
  const elementRef = useRef(null);
  const [dataProps, setDataProps] = useState<any>(null);
  const cmpBadge = useRef<HTMLDivElement | null>(null);
  
  useEffect(() => {
      if (cmpBadge.current) {
          const parentEl = cmpBadge.current?.parentElement;
          if (parentEl?.dataset) {
              const attr = parentEl.getAttribute("data-props");

              if (attr) {
                try {
                  const dataValueProps = JSON.parse(attr);
                  setDataProps(dataValueProps);
                } catch (error) {
                  console.error('invalid badge props', error);
                }
              }
              
          }
      }
  }, []);

  return (
    <div ref={cmpBadge}>
      <Provider theme={lightTheme} colorScheme="light">
        <div className={styles.dashboardcontainer} id="badges" >
          {/* <div className={styles.pagecontainer}> */}
          <div className={styles.headingContainer}>
              <h4 className={styles.heading}>
                {dataProps?.componentTitle || `My Certificates`}
              </h4>
            </div>

            <div className={styles.badgebody}>
              <div className={styles.badgecontainer}>
                {isLoading ? (
                  <ALMLoader classes={styles.loader} />
                ) : (
                  <>
                    {badges?.length === 0 ? <div className={styles.noResult}>{dataProps?.noResultText || `You haven't completed any courses yet. Browse courses to get started.`}</div> : <BadgeList
                      badges={badges}
                      handleDownloadPdfClick={handleDownloadPdfClick}
                      handleDownloadImgClick={handleDownloadImgClick}
                      handleRedirectToCourse={handleRedirectToCourse}
                      redirectUrl={dataProps?.detailPagePath}
                      handleDownloadAllCheckedPdf={handleDownloadAllCheckedPdf}
                      handleDownloadAllCheckedImg={handleDownloadAllCheckedImg}
                    />}
                  </>
                )}
                <div ref={elementRef}></div>
              </div>
            </div>
            {/* Buttons are for testing functionality only */}
            <div className={styles.paginationContainer}>
              {badges?.length === 0 ? '' : <><button onClick={handlePrevPage} className={`${styles.paginationBtn} ${isPrevDisable && styles.disabled}`} aria-label="Prev" />
              <button onClick={handleNextPage} className={`${styles.paginationBtn} ${isNextDisable && styles.disabled}`} aria-label="Next" /></>}
            </div>
          </div>
        {/* </div> */}
      </Provider>
    </div>
  );
};

export default Badges;
